export default function Testimonials() {
  const testimonials = [
    {
      name: 'María González',
      business: 'Café Aroma',
      text: 'El logotipo que diseñaron para mi cafetería superó todas mis expectativas. Ahora mis clientes reconocen mi marca al instante. ¡Totalmente recomendados!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/164b209320cd4d8abc0867d8c3ae275d.jpg'
    },
    {
      name: 'Carlos Ramírez',
      business: 'Tech Solutions',
      text: 'Necesitaba una identidad visual completa para mi startup tecnológica. El equipo entendió perfectamente mi visión y creó algo increíble.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20male%20tech%20entrepreneur%20in%20modern%20office%2C%20confident%20business%20owner%2C%20natural%20lighting%2C%20authentic%20professional%20photo%2C%20simple%20background%2C%20high%20quality%20photography&width=150&height=150&seq=testimonial-carlos-002&orientation=squarish'
    },
    {
      name: 'Ana Martínez',
      business: 'Boutique Elegance',
      text: 'Los diseños para mis redes sociales han aumentado mi engagement un 300%. Son creativos, profesionales y siempre entregan a tiempo.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20woman%20fashion%20boutique%20owner%20smiling%2C%20elegant%20business%20owner%2C%20natural%20lighting%2C%20authentic%20entrepreneur%20photo%2C%20simple%20background%2C%20high%20quality%20photography&width=150&height=150&seq=testimonial-ana-003&orientation=squarish'
    },
    {
      name: 'Roberto Silva',
      business: 'Fitness Pro',
      text: 'Los flyers y banners que diseñaron para mi gimnasio son espectaculares. He visto un aumento significativo en nuevos clientes.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20male%20fitness%20gym%20owner%2C%20athletic%20business%20owner%20smiling%2C%20natural%20lighting%2C%20authentic%20entrepreneur%20photo%2C%20simple%20background%2C%20high%20quality%20photography&width=150&height=150&seq=testimonial-roberto-004&orientation=squarish'
    },
    {
      name: 'Laura Fernández',
      business: 'Dulce Tentación',
      text: 'Mi negocio de repostería necesitaba una imagen profesional. Logo Ideas creó un branding dulce y elegante que mis clientes adoran.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20woman%20bakery%20owner%20smiling%20warmly%2C%20pastry%20business%20owner%2C%20natural%20lighting%2C%20authentic%20entrepreneur%20photo%2C%20simple%20background%2C%20high%20quality%20photography&width=150&height=150&seq=testimonial-laura-005&orientation=squarish'
    },
    {
      name: 'Diego Morales',
      business: 'Constructora DM',
      text: 'Buscaba un logotipo corporativo serio y profesional. El resultado fue exactamente lo que necesitaba para proyectar confianza.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20male%20construction%20company%20owner%20in%20business%20attire%2C%20confident%20contractor%2C%20natural%20lighting%2C%20authentic%20entrepreneur%20photo%2C%20simple%20background%2C%20high%20quality%20photography&width=150&height=150&seq=testimonial-diego-006&orientation=squarish'
    }
  ];

  return (
    <section id="testimonios" className="py-24 bg-gradient-to-b from-[#2d1b4e] via-[#1a0b2e] to-[#0f0520] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#ff00aa] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 px-5 py-2 rounded-full mb-6">
            <span className="text-xs font-bold text-[#00ffff] uppercase tracking-wide">
              Testimonios
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-[#c0c0ff]">
            Historias reales de negocios que transformamos con diseño profesional
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-8 hover:border-[#ff00ff]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#ff00ff]/30 hover:scale-105"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-[#00ffff]"></i>
                ))}
              </div>

              {/* Text */}
              <p className="text-[#c0c0ff] leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-[#00ffff]/20">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#00ffff]/50 shadow-lg shadow-[#00ffff]/30">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-white">{testimonial.name}</h4>
                  <p className="text-sm text-[#00ffff]">{testimonial.business}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
